var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneToHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glyphicons-basic",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "phone-to-horizontal",
    d: "M16.5,4H5.5A2.50231,2.50231,0,0,0,3,6.5v19A2.50231,2.50231,0,0,0,5.5,28h11A2.50231,2.50231,0,0,0,19,25.5V6.5A2.50231,2.50231,0,0,0,16.5,4ZM12,25.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5ZM16,22H6V7H16Zm15-6.5v10A2.50231,2.50231,0,0,1,28.5,28H21V25h7V16H21V13h7.5A2.50231,2.50231,0,0,1,31,15.5ZM24,5H22V3h2a3.00328,3.00328,0,0,1,3,3V7h1.23114c.55634,0,.73511.36163.39728.80359L26.39728,10.7229a.47526.47526,0,0,1-.79456,0L23.37158,7.80359C23.03375,7.36163,23.21252,7,23.76886,7H25V6A1.00067,1.00067,0,0,0,24,5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneToHorizontal);
export default __webpack_public_path__ + "static/media/phone-to-horizontal.327e5952023287f6d473c563d0624e42.svg";
export { ForwardRef as ReactComponent };